import { render, staticRenderFns } from "./TixStepper.vue?vue&type=template&id=72f56d7c&"
import script from "./TixStepper.vue?vue&type=script&lang=ts&"
export * from "./TixStepper.vue?vue&type=script&lang=ts&"
import style0 from "./TixStepper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports